import React from "react";

import { SingleSelect, Textfield, PrimaryButton,SecondaryButton } from "widgets";
import {
  MIN_BRANCH_NAME_SEARCH_LENGTH,
  SEARCH_VALIDATION_MESSAGES,
} from "../../constants/constants";

import styles from "./SearchTenants.module.scss";

const searchTenantByOptions = [
    { value: "code", label: "Code" },
    { value: "name", label: "Name" },
];
const SEARCH_TENANT_BY_CODE = "code";
const SEARCH_TENANT_BY_NAME = "name";

const getSearchError = (searchTenantBy, searchValue) => {
    const rawValue = String(searchValue || "");
    if (!rawValue) return null;
    const trimmedValue = rawValue.trim();
    if (!trimmedValue) {
        return SEARCH_VALIDATION_MESSAGES.SEARCH_VALUE_BLANK;
    }
    if (
        searchTenantBy === SEARCH_TENANT_BY_NAME &&
        trimmedValue.length < MIN_BRANCH_NAME_SEARCH_LENGTH
    ) {
        return `Search term must be at least ${MIN_BRANCH_NAME_SEARCH_LENGTH} characters`;
    }
    return null;
};

const isSearchButtonDisabled = (searchTenantBy, searchValue) => {
    const trimmedValue = String(searchValue || "").trim();
    if (!trimmedValue) {
        return true;
    }
    if (searchTenantBy === SEARCH_TENANT_BY_CODE) {
        return false;
    }
    if (searchTenantBy === SEARCH_TENANT_BY_NAME) {
        return trimmedValue.length < MIN_BRANCH_NAME_SEARCH_LENGTH;
    }
    return true;
};

const SearchTenants = (props) => {
    const {
        searchTenantBy,
        setSearchTenantBy,
        searchValue,
        setSearchValue,
        handleOnClickSearchButton,
        isLoading,
        handleOnClickClearButton,
    } = props;
    const searchError = getSearchError(searchTenantBy, searchValue);

    const handleSearchByChange = (event) => {
        setSearchTenantBy(event.target.value);
        setSearchValue("");
    };

    return (
        <div className={styles.searchTypeContainer}>
            <div className={styles.searchByField}>
                <SingleSelect
                    tag="Search By"
                    menuItems={searchTenantByOptions}
                    value={searchTenantBy}
                    handleChange={handleSearchByChange}
                />
            </div>
            <div className={styles.searchTermField}>
                <Textfield
                    label="Enter search term"
                    value={searchValue}
                    handleOnChange={(e) => setSearchValue(e.target.value)}
                    error={Boolean(searchError)}
                    helperText={searchError}
                />
            </div>
            <div className={styles.searchActions}>
                <PrimaryButton
                    onClick={handleOnClickSearchButton}
                    disabled={isSearchButtonDisabled(searchTenantBy, searchValue) || isLoading}
                >
                    {isLoading ? "Searching..." : "Search"}
                </PrimaryButton>
                <SecondaryButton onClick={handleOnClickClearButton}>Clear</SecondaryButton>
            </div>
        </div>
    );
};

export default SearchTenants;
